import { useStack } from '@/react/common/stacks/queries/useStack';

import { appStackIdLabel, appStackKindLabel } from '../../constants';
import { Application } from '../../types';
import { isExternalApplication } from '../../utils';

export function useAppStack(app?: Application) {
  const { stackId: appStackId, stackKind: appStackKind } =
    getStackDetailsFromLabels(app);

  const externalApp = !!app && isExternalApplication(app);

  const isManagedStack =
    !!appStackId && !externalApp && appStackKind !== 'edge';

  const query = useStack(appStackId, { enabled: isManagedStack });

  return query;
}

export function getStackDetailsFromLabels(app?: Application): {
  stackId?: number;
  stackKind?: string;
} {
  const appStackId = parseStackId(app);
  const appStackKind = app?.metadata?.labels?.[appStackKindLabel];
  return { stackId: appStackId, stackKind: appStackKind };
}

function parseStackId(app?: Application) {
  const rawStackId = app?.metadata?.labels?.[appStackIdLabel];
  const parsedStackId = rawStackId ? parseInt(rawStackId, 10) : NaN;
  return Number.isNaN(parsedStackId) ? undefined : parsedStackId;
}
